import { z } from 'zod';
import { AgentSlugSchema, SlugSchema } from '../common.js';
/**
 * Public lookup record that maps a (tenantSlug, agentSlug) pair to the
 * underlying UUIDs and agent status — see docs/data-model.md §4.9.
 * Enables the public embed runtime to resolve a human-readable URL to agent
 * config without scanning or requiring auth.
 *
 * PK = AGENT-LOOKUP#<tenantSlug>, SK = <agentSlug>
 * (written transactionally with Agent create/update/delete)
 */
export const AgentPublicLookupSchema = z.object({
    tenantSlug: SlugSchema,
    agentSlug: AgentSlugSchema,
    tenantId: z.string().uuid(),
    agentId: z.string().uuid(),
    status: z.enum(['active', 'paused', 'archived']),
});
//# sourceMappingURL=agentPublicLookup.js.map